__turbopack_context__.v({
  "alertYellow": "dFgOva_alertYellow",
  "authorDetails": "dFgOva_authorDetails",
  "authorImage": "dFgOva_authorImage",
  "authorPosition": "dFgOva_authorPosition",
  "black": "dFgOva_black",
  "black90": "dFgOva_black90",
  "contentSection": "dFgOva_contentSection",
  "cyan": "dFgOva_cyan",
  "darkStone": "dFgOva_darkStone",
  "fuschiaPunch": "dFgOva_fuschiaPunch",
  "inCardPanel": "dFgOva_inCardPanel",
  "isBlog": "dFgOva_isBlog",
  "limeSorbet": "dFgOva_limeSorbet",
  "noPad": "dFgOva_noPad",
  "olive100": "dFgOva_olive100",
  "olive20": "dFgOva_olive20",
  "openingQuote": "dFgOva_openingQuote",
  "paddingBottom0": "dFgOva_paddingBottom0",
  "paddingBottom112": "dFgOva_paddingBottom112",
  "paddingBottom128": "dFgOva_paddingBottom128",
  "paddingBottom16": "dFgOva_paddingBottom16",
  "paddingBottom32": "dFgOva_paddingBottom32",
  "paddingBottom48": "dFgOva_paddingBottom48",
  "paddingBottom64": "dFgOva_paddingBottom64",
  "paddingBottom80": "dFgOva_paddingBottom80",
  "paddingBottom96": "dFgOva_paddingBottom96",
  "paddingTop0": "dFgOva_paddingTop0",
  "paddingTop112": "dFgOva_paddingTop112",
  "paddingTop128": "dFgOva_paddingTop128",
  "paddingTop16": "dFgOva_paddingTop16",
  "paddingTop32": "dFgOva_paddingTop32",
  "paddingTop48": "dFgOva_paddingTop48",
  "paddingTop64": "dFgOva_paddingTop64",
  "paddingTop80": "dFgOva_paddingTop80",
  "paddingTop96": "dFgOva_paddingTop96",
  "quoteCard": "dFgOva_quoteCard",
  "quoteSection": "dFgOva_quoteSection",
  "softBlack": "dFgOva_softBlack",
  "teal100": "dFgOva_teal100",
  "teal20": "dFgOva_teal20",
  "warmStone": "dFgOva_warmStone",
  "white": "dFgOva_white",
});
